module.exports = __webpack_public_path__ + "img/warning-important.c8ae5e7d.svg";